import React from "react";
import { FaPuzzlePiece, FaUser, FaClock, FaUniversity, FaShieldAlt } from "react-icons/fa";
import { MdOutlineMail, MdOutlinePhoneInTalk } from "react-icons/md";
import pricingBG from '../assets/image/pricingBg.png';
const Pricing = ({ MarginTop }) => {
    const data = [
        {
            icon: <FaPuzzlePiece />,
            title: "Start Your Way",
            color: "#F7A84F",
            text: "Start with one module (underwriting, collections, disbursements,reporting) or go end-to-end.",
        },
        {
            icon: <FaUser />,
            title: "Usage-Based Pricing",
            color: "#2F8BFF",
            text: "Pricing is based on active users and loan volume, not a flat seat license.",
        },
        {
            icon: <FaClock />,
            title: "Fast Implementation",
            color: "#34D17B",
            text: "Implementation is measured in days, not months — no lengthy consultancy engagement required.",
        },
        {
            icon: <FaShieldAlt />,
            title: "No Lock-In",
            color: "#B15BFF",
            text: "No long-term lock-in until you're confident it works for you.",
        },
    ];

    return (
        <section id="pricing" className='about-sec-cont' style={{ scrollMarginTop: MarginTop }}>
            <img src={pricingBG} className="price-bg-img" alt="pricing_background_image" />
            <div className="section-badge">
                <span className="title-side-line"></span>
                <h5 className="badge-text">Pricing That Fits</h5>
                <span className="title-side-line"></span>
            </div>
            <div className="title-section">
                <h1 className="head-title">How It <span>Works</span></h1>
                <span className="title-under-line"></span>
                <p className="title-disc">Our platform is modular — <span className="uniq-cont-text-colr">you pay only</span> for the capabilities you deploy, not a bundled package with features you'll never use.</p>
            </div>
            <div className="pricingSection">
                <div className="service-content">
                    <h4 className="extra-size"> How it works: </h4>
                    <div className="service-line"></div>
                </div>

                <div className="pricing-cards">
                    {data.map((item, index) => (
                        <div
                            className={`pricing-single-card ${index !== data.length - 1 ? "borderRight" : ""}`}
                            key={index}
                        >
                            <div
                                className="iconCircle"
                                style={{
                                    color: item.color,
                                    borderColor: item.color,
                                    boxShadow: `0 0 25px ${item.color}25`,
                                }}
                            >
                                {item.icon}
                            </div>

                            <h3>{item.title}</h3>

                            <p>{item.text}</p>
                        </div>
                    ))}
                </div>

                <div className="bottomInfo">
                    <div className="bankIcon">
                        <FaUniversity />
                    </div>

                    <p>
                        Whether you're a small NBFC or a large bank looking to modernize a
                        specific workflow, the structure
                        <span> scales with you.</span>
                    </p>
                </div>
            </div>
            <div className='privacy-and-terms mt-3 pricing-tab-cont'>
                <div className="policy-wrapper">
                    <div className="privacy-info price-info">
                        <div className="policy-icon"><FaShieldAlt /></div>
                        <div className="privacy-content">
                            <div className="service-content">
                                <h4 className="extra-size"> Let's Talk </h4>
                                <div className="service-line"></div>
                            </div>
                            <p>
                                Get a quote in 24 hours. Tell us which modules you need and your approximate monthly loan volume — we'll send a ballpark figure before any formal conversation.
                            </p>
                        </div>
                    </div>
                    <div className="price-lets-talk-cont">
                        <h4> Contact Us to begin the conversation. </h4>
                        <div className="price-contact-info">
                            <div className="pricing-talk-card">
                                <div className="price-card">
                                    <div className="policy-icon"> <MdOutlineMail /></div>
                                    <div className="contact-price-cont">
                                        <a href='mailto:contact@bwefinserv.com' target='_blank' rel="noreferrer">contact@bwefinserv.com</a>
                                    </div>
                                </div>
                                {/* <div className="price-card">
                                    <div className="policy-icon"> <MdOutlineMail /></div>
                                    <div className="contact-price-cont">
                                        <a href='mailto:radhakrishna@bwefinserv.com' target='_blank' rel="noreferrer">radhakrishna@bwefinserv.com</a>
                                    </div>
                                </div> */}
                            </div>
                            <div className="price-card">
                                <div className="policy-icon"> <MdOutlinePhoneInTalk /></div>
                                <div className="contact-price-cont">
                                    <a href='tel:6383830073' target='_blank' rel="noreferrer">63838 30073</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )

}

export default Pricing;